module.exports = __webpack_public_path__ + "static/media/logo.52409603.png";